<template>
    <div class="navbar-container d-flex content align-items-center">
        <!-- Nav Menu Toggler -->
        <ul class="nav navbar-nav d-xl-none">
            <li class="nav-item">
                <b-link class="nav-link" @click="toggleVerticalMenuActive">
                    <feather-icon icon="MenuIcon" size="21" />
                </b-link>
            </li>
        </ul>
        <slot name="dashboard-header-left"></slot>
        <!-- Left Col -->
        <slot name="dashboard-header-right">
            <b-navbar-nav class="nav align-items-center ml-auto">
                <Locale></Locale>
                <NoticeDropdown :loadingStatus="loading"></NoticeDropdown>
                <DarkToggler class="d-none d-lg-block" />
                <UserDropdown></UserDropdown>
            </b-navbar-nav>
        </slot>
    </div>
</template>

<script>
import NoticeDropdown from './NoticeDropdown'
import DarkToggler from './DarkToggler'
import Locale from './Locale'
import UserDropdown from './UserDropdown'
import { getCurrentInstance, computed, watch, ref } from '@vue/composition-api'
export default {
    components: {
        NoticeDropdown,
        DarkToggler,
        Locale,
        UserDropdown
    },
    props: {
        toggleVerticalMenuActive: {
            type: Function,
            default: () => { }
        }
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        const loading = ref(true)
        const getBoardDocuments = () => store.dispatch('getBoardDocuments')

        const needPrerequisite = computed(() => store.getters.needPrerequisite)
        const boardDocuments = computed(() => store.getters.boardDocuments)
        const userIdx = computed(() => store.getters.authUserInfo.userIdx)

        /* watch */
        watch(userIdx, (value, oldValue) => {
            if (needPrerequisite.value) return
            if (value && !oldValue) {
                getBoardDocuments().then(() => {
                    if (!boardDocuments.value.length) {
                        throw ReferenceError('boardDocuments length is 0')
                    }
                    loading.value = false
                }).catch(error => {
                    if (error instanceof ReferenceError) {
                        loading.value = false
                    }
                })
            }
        }, {
            immediate: true
        })

        return {
            loading
        }
    }
}
</script>
